import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import useSWRImmutable from 'swr/immutable';
export var toUseStartLiveClass = function toUseStartLiveClass(WorkoutFetchers) {
  return function (params) {
    var _workout$error, _workout$error$respon, _workout$error$respon2;

    var workout = useSWRImmutable.apply(void 0, _toConsumableArray(WorkoutFetchers.CreateWorkout({
      pelotonId: params.pelotonId,
      streamSubscriptionId: params.streamSubscriptionId,
      streamSubscriptionIdType: params.streamSubscriptionIdType,
      workoutType: 'class',
      analyticsProps: params.analyticsProps
    })));
    return {
      data: {
        workout: workout.data
      },
      errors: [workout === null || workout === void 0 ? void 0 : (_workout$error = workout.error) === null || _workout$error === void 0 ? void 0 : (_workout$error$respon = _workout$error.response) === null || _workout$error$respon === void 0 ? void 0 : (_workout$error$respon2 = _workout$error$respon.data) === null || _workout$error$respon2 === void 0 ? void 0 : _workout$error$respon2.errorCode],
      isValidating: workout.isValidating
    };
  };
};